import { connect } from "react-redux";
import React, { Component } from "react";
import FormElement from "components/FormElement";
import { handleInputChange, setValue } from "actions/request";
import {
  fetchModelCRR,
  mapSelectedModelFields
} from "actions/battery/crrRequest";
import { hasStringValue } from "helpers/RequestHelper";
import * as formHelper from "helpers/FormHelper";
import * as modelHelper from "helpers/ModelHelper";

class RequestEcoModelCRR extends Component {
  state = { touched: false, fieldName: "existedModel" };

  componentDidMount() {
    this.setState({
      fieldName: formHelper.defineModelFieldId(this.props.request)
    });
  }

  isValidationRequired = () => {
    return this.props.user.canEditModelname;
  };

  validateModelName() {
    if (!this.isValidationRequired() || !this.state.touched) return null;

    return hasStringValue(this.props.request, this.state.fieldName)
      ? null
      : "error";
  }

  onFieldChanged = event => {
    if (!this.state.touched) {
      this.setState({ touched: true });
    }

    const model = modelHelper.findExistedModelByName(
      event.target.value,
      this.props.requests.crrEcoModels
    );

    if (model) {
      this.props.setValue("modelName", event.target.value);
      this.props
        .fetchModelCRR(model.value, this.props.request.ieee)
        .then(() =>
          this.props.mapSelectedModelFields(model.devicemodelbatterycomponent)
        )
        .then(() => this.props.handleInputChange(event));
    } else {
      console.error("Model for CRR request can't be found.");
    }
  };

  render() {
    const { requests, request } = this.props;
    const isEditable = this.isValidationRequired();
    const inputType = formHelper.defineEcoModelFieldType(isEditable, request);
    const modelName = formHelper.defineEcoModelName(isEditable, request);
    const { crrEcoModels } = requests || [];

    return (
      <FormElement
        id={this.state.fieldName}
        type={inputType}
        label="Model Name/Number"
        value={modelName}
        options={crrEcoModels}
        editable={isEditable}
        onChange={this.onFieldChanged}
        validationState={this.validateModelName()}
        validationMessage={formHelper.emptyMsg}
        customOptions={{
          combobox: false,
          notFoundContent: "Model Name not found"
        }}
        useIdAsValue={true}
      />
    );
  }
}

function mapStateToProps({ requests, request, user }) {
  return { requests, request, user };
}

export default connect(mapStateToProps, {
  handleInputChange,
  setValue,
  fetchModelCRR,
  mapSelectedModelFields
})(RequestEcoModelCRR);
